﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1
/* eslint-disable */

import { TranslationLabels } from "./TranslationLabels";
export const germanLabels: TranslationLabels = {
  Actions: "Aktionen",
  Actions_Activate: "Aktivieren",
  Actions_Add: "Hinzufügen",
  Actions_AddBoard: "Gremium hinzufügen",
  Actions_AddComment: "Kommentar hinzufügen",
  Actions_AddRun: "Lauf hinzufügen",
  Actions_AddTopic: "Geschäft hinzufügen",
  Actions_Back: "Zurück",
  Actions_Cancel: "Abbrechen",
  Actions_ChangeRunStatus: "Status ändern",
  Actions_CreateEmail_Success: "E-Mail erfolgreich erstellt.",
  Actions_Deactivate: "Deaktivieren",
  Actions_Delete: "Löschen",
  Actions_DeleteBoard: "Gremium löschen",
  Actions_DeleteRun: "Lauf löschen",
  Actions_DeleteRunTopic: "Geschäft löschen",
  Actions_DownloadBoardsExcel: "Gremiumsliste herunterladen",
  Actions_DownloadConfiguration: "Konfiguration herunterladen",
  Actions_DownloadFile: "Datei '{name}' herunterladen …",
  Actions_DownloadRunDocuments: "Zip mit allen Dokumenten herunterladen",
  Actions_DownloadRunDocuments_Empty: "Es gibt keine Beilage-Dateien zum herunterladen.",
  Actions_Edit: "Bearbeiten",
  Actions_EditBoard: "Gremium bearbeiten",
  Actions_EditComment: "Kommentar bearbeiten",
  Actions_EditRun: "Lauf bearbeiten",
  Actions_EditTopic: "Geschäft bearbeiten",
  Actions_GoToBoard: "Gremium Einstellungen öffnen",
  Actions_GoToRuns: "Gremium Läufe öffnen",
  Actions_GoToVote: "Zur Abstimmung",
  Actions_Help: "Hilfe",
  Actions_HideChildren: "Untergeordnete Elemente ausblenden",
  Actions_HideDiff: "Unterschiede ausblenden",
  Actions_None: "Keine",
  Actions_Open: "Öffnen",
  Actions_Opendocument: "Dokument öffnen",
  Actions_OpenPhonebook: "Telefonbuch öffnen",
  Actions_OpenUserProfile: "Benutzerprofil öffnen",
  Actions_PublishRun: "Einladungen senden und Lauf publizieren",
  Actions_Refresh: "Neu Laden",
  Actions_Reset: "Zurücksetzen",
  Actions_Save: "Speichern",
  Actions_SendEmail_Success: "Email erfolgreich gesendet.",
  Actions_SendReminders: "Erinnerungen senden",
  Actions_SendSiveResults_Failure: "Ergebnis kann nicht nach SiVe gesendet werden!",
  Actions_SendSiveResults_Success: "Ergebnis erfolgreich nach SiVe gesendet.",
  Actions_SendToSive: "Ergebnisse an SiVe senden",
  Actions_ShowChildren: "Untergeordnete Elemente anzeigen",
  Actions_ShowDiff: "Unterschiede anzeigen",
  Actions_Synchronize: "Synchronisieren",
  Actions_ToggleComments: "Kommentare anzeigen",
  Actions_ToggleResults: "Ergebnisse anzeigen",
  Actions_ToggleTopics: "Alle Geschäfte aufklappen/minimieren",
  Actions_UploadDocument: "Dokument hinzufügen",
  Actions_View: "Details",
  Actions_View_History: "Versionsverlauf",
  Actions_ViewHistory: "Historie öffnen",
  AddUser_Label: "User hinzufügen",
  AdminChart_Answered: "komplett beatnwortet",
  AdminChart_NoResults: "Kein Fortschritt",
  AdminChart_NotAnswered: "nicht oder nicht komplett beantwortet",
  Administration_Restriction: "Nur Administratoren haben Zugriff auf diese Seite.",
  AdministratorsHaveAccessToo: "Die bestehenden Administratoren der Anwendung haben ebenfalls Zugang.",
  AdminUsersFilter_Placeholder: "Suche nach Users …",
  AliasOptional: "Alias (optional)",
  Answer_Abstention: "Stimmenthaltung",
  Answer_Acknowledged: "Zur Kenntnis genommen",
  Answer_Discussion_Required: "Antrag auf Diskussion",
  Answer_Group_Done: "abgestimmt/beantwortet",
  Answer_Group_Todo: "abstimmen/antworten",
  Answer_No: "Nein",
  Answer_Not_Answer: "Antwort unbekannt",
  Answer_Response_Abstention: "Stimmenthaltung: {{totalAnswer}}",
  Answer_Response_Acknowledged: "Zur Kenntnis genommen: {{totalAnswer}}",
  Answer_Response_Discussion_Required: "Antrag auf Diskussion: {{totalAnswer}}",
  Answer_Response_No: "Nein, stimme dem Antrag nicht zu: {{totalAnswer}}",
  Answer_Response_Not_Answer: "Offen: {{totalAnswer}}",
  Answer_Response_Yes: "Ja, ich stimme dem Antrag zu: {{totalAnswer}}",
  Answer_Response_Yes_But: "Ja, aber: {{totalAnswer}}",
  Answer_Yes: "Ja",
  Answer_Yes_But: "Ja, aber",
  App_Version: "Version",
  ApplicationName: "eDecide",
  AuditLog: "Versionsverlauf",
  AuditLog_Action: "Aktion",
  AuditLog_Add: "Hinzugefügt",
  AuditLog_After: "Nachher",
  AuditLog_Before: "Vorher",
  AuditLog_Changes: "Änderungen",
  AuditLog_Created: "Geändert am",
  AuditLog_CreatedBy: "Geändert von",
  AuditLog_Date: "Am",
  AuditLog_Diff: "Unterschiede",
  AuditLog_Id: "Id",
  AuditLog_Properties: "Felder",
  AuditLog_Property: "Feld",
  AuditLog_Remove: "Gelöscht",
  AuditLog_State: "Aktion",
  AuditLog_Update: "Geändert",
  AuditLog_User: "Von",
  AuditLogs: "Versionsverläufe",
  Auth_Loading: "Lade Applikation …",
  Auth_LoginFailed: "Anmeldung fehlgeschlagen.",
  Auth_Redirecting: "Lade Anmeldung …",
  Auth_TryAgain: "Versuche es nochmals.",
  BackHome: "Zurück zur Startseite",
  Board: "Gremium",
  Board_Description: "Beschreibung",
  Board_Members: "Mitglieder",
  Board_Members_Add: "Mitglied hinzufügen",
  Board_Name: "Name",
  Board_Owners: "Besitzer",
  Board_Owners_Add: "Besitzer hinzufügen",
  Board_RunThresholdDays: "Archivierte Läufe älter als {{runThresholdDays}} Tage werden nicht angezeigt",
  Board_Status: "Status",
  Board_Statuses: "Status",
  Board_TopicKindCodes: "Verfügbare Geschäftstypen",
  Board_UniqueId: "ID",
  BoardConfiguration: "Konfiguration",
  BoardConfiguration_Emailtemplate: "Email-Vorlage",
  BoardConfiguration_ReportTemplate: "Berichtsvorlage",
  BoardRole: "Gremiumrolle",
  BoardRole_Member: "Mitglied",
  BoardRole_Owner: "Besitzer",
  BoardRoles: "Gremiumrollen",
  Boards: "Gremien",
  Boards_Empty: "Kein Gremium vorhanden.",
  Boards_NotFound: "Es wurde keine Gremien mit diesen Kriterien gefunden",
  BoardStatus_Active: "aktiv",
  BoardStatus_Archived: "archiviert",
  BoardStatus_Inactive: "inaktiv",
  By: "von",
  Cancel: "Abbrechen",
  ClaimIssuer: "Aussteller von Ansprüchen",
  Claims: "Benutzeransprüche",
  ClaimType: "Anspruchsart",
  Confirm: "Ich bestätige",
  Confirm_Cancel: "Abbrechen",
  Confirm_Content: "Es wurden ungespeicherte Änderungen erkannt. Willst du die Änderungen wirklich verwerfen?",
  Confirm_DeleteBoard_Text: "Soll das Gremium {{name}} gelöscht werden?",
  Confirm_DeleteEmailTemplate_Text: "E-Mail-Vorlage {{name}} löschen",
  Confirm_DeleteReportTemplate_Text: "Dokument {{name}} löschen",
  Confirm_DeleteRun_Text: "Lauf {{title}} löschen?",
  Confirm_Discard: "Änderungen verwerfen",
  Confirm_RunStatus_Change: "Bitte bestätige die Statusänderung von {oldStatus} zu {newStatus}.",
  Confirm_RunStatus_Change_To_Archive_Title: "Lauf archivieren",
  Confirm_RunStatus_Change_To_Close: "Bitte bestätige die Statusänderung von '{oldStatus}' zu 'Geschlossen'. Bei vorhandener SiVe Verknüpfung (Externe ID) werden die Ergebnisse automatisiert nach dem Schliessen übermittelt.",
  Confirm_RunStatus_Change_To_Close_Title: "Lauf schliessen",
  Confirm_RunStatus_Change_To_Publish_Title: "Lauf publizieren",
  Confirm_RunStatus_Change_To_Revise: "Bitte bestätige die Statusänderung von «{oldStatus}» zu «Überarbeitung». Im Status «Überarbeitung» können die Laufeigenschaften wie Enddatum und Titel angepasst sowie neue Teilnehmer hinzugefügt werden.",
  Confirm_RunStatus_Change_To_Revise_Title: "Lauf überarbeiten",
  Confirm_Title: "Ungespeicherte Änderungen",
  CopyToClipboard_Idle: "In Zwischenlage kopieren…",
  CopyToClipboard_Success: "Kopiert!",
  Created: "Erstellt",
  Date_Group_All: "Alle",
  Date_Group_Oneyear: "maximal 1 Jahr alt",
  Date_Group_Twomonths: "maximal 2 Monate alt",
  Date_Group_Twoyears: "maximal 2 Jahre alt",
  Date_Unknown: "Unbekanntes Datum",
  De: "Deutsch",
  Details: "Details",
  DismissableDialog_Close_Label: "Schlissen",
  DismissableDialog_Close_Tooltip: "Meldung nicht mehr anzeigen",
  Download: "Herunterladen",
  Edit: "Bearbeiten",
  Email_Invitation_Subject: "eDecide-Lauf {{run.title}}",
  Email_Reminder_Publish: `{{boardName}} - eDecide Lauf {{runTitle}}
Dies ist eine automatisch generierte E-Mail.<br><br>
Werte Sitzungsteilnehmende<br><br>
Der eDecide-Lauf wurde eben eröffnet. Bitte geben Sie Ihre Stimme bis am {{expiryDate}} um {{expiryTime}} Uhr ab.<br><br>
Durch Klicken auf nachfolgenden Link gelangen Sie direkt zur Abstimmung: <a href='{{voteLink}}'>{{runTitle}}</a><br><br>
Beste Grüsse,<br><br>
{{boardOwnerName}}<br>
Sitzungsadministrator<br><br>

============================REPUBLISH============================


{{boardName}} - eDecide run {{runTitle}}
Dies ist eine automatisch generierte E-Mail.<br><br>
Werte Sitzungsteilnehmende<br><br>
Der eDecide-Lauf wurde eben erneut eröffnet. Bitte geben Sie Ihre Stimme bis am {{expiryDate}} um {{expiryTime}} Uhr ab.<br><br>
Durch Klicken auf nachfolgenden Link gelangen Sie direkt zur Abstimmung: <a href='{{voteLink}}'>{{runTitle}}</a><br><br>
Beste Grüsse,<br><br>
{{boardOwnerName}}<br>
Sitzungsadministrator`,
  Email_Reminder_Subject: "Erinnerung {{title}}",
  EmptyTable: "Keine Daten in der Tabelle vorhanden",
  En: "English",
  Entity: "Entität",
  Entity_Add_Failure: "{EntityName} konnte nicht erstellt werden.",
  Entity_Add_Success: "{EntityName} erfolgreich erstellt.",
  Entity_Delete_ConfirmContent: "Willst du {EntityName} wirklich löschen?",
  Entity_Delete_ConfirmTitle: "Löschen bestätigen",
  Entity_Delete_Failure: "{EntityName} konnte nicht gelöscht werden.",
  Entity_Delete_Success: "{EntityName} erfolgreich gelöscht.",
  Entity_Refresh_Failure: "{EntityName} konnte nicht neugeladen werden.",
  Entity_Refresh_Success: "{EntityName} erfolgreich neugeladen.",
  Entity_Save_Failure: "{EntityName} konnte nicht gespeichert werden.",
  Entity_Save_Success: "{EntityName} erfolgreich gepeichert.",
  Entity_Update_Failure: "{EntityName} konnte nicht aktualisiert werden.",
  Entity_Update_Success: "{EntityName} erfolgreich aktualisiert.",
  EntityCount: "# Einträge",
  EntityTitle_Unknown: "Unbekannt",
  Error_FailedToAddUser: "Benutzer '{0}' konnte nicht hinzugefügt werden.",
  ErrorCodes_BadRequest: "Bei der Abfrage ist etwas fehlgeschlagen. Es handelt sich um einen Client-Fehler (zum Beispiel: fehlerhafte Anfragesyntax, ungültiges Framing der Anfragemeldung oder irreführendes Anfrage-Routing).",
  ErrorCodes_InternalServerError: "Bei der Bearbeitung Deiner Anfrage ist ein Fehler aufgetreten.",
  ErrorCodes_NoResponse: "Der Backend Dienst ist nicht erreichbar.",
  ErrorCodes_NotFound: "Die Ressource wurde nicht gefunden.",
  ErrorCodes_Unauthorized: "Du hast keine Berechtigungen für den Zugriff auf die Ressource.",
  Exception: "Ausnahme",
  Exists: "Existiert",
  File_Picker_Not_Valid_File: "Dateiformat ungültig!",
  FileAction_Delete: "Wird gelöscht",
  FileAction_Existing: "Bestehend",
  FileAction_New: "Wird hochgeladen",
  FileAction_Overwrite: "Wird überschrieben",
  FileUpload_ProtectedFile_Message: "Die hochgeladene Datei '{0}' wurde als verschlüsselt erkannt.",
  FileUpload_ProtectedFile_Title: "Geschützte Datei wird nicht hochgeladen",
  Filter_Active_Icon_Tooltip: "Filter bearbeiten",
  Filter_Clear_Icon_Tooltip: "Filter entfernen",
  Filter_Combobox_Filter_Customize: "Filter",
  Filter_Icon_Tooltip: "Filter anwenden",
  Filter_Search_Placeholder: "Suchen…",
  Footer_HelpAndSupport: "Hilfe & Support",
  Footer_HelpTitle: "SBB eDecide Hilfe",
  Footer_Imprint: "Impressum",
  Footer_Title: "Impressum und Hilfe",
  Fr: "Français",
  Group: "Gruppe",
  Group_Add: "Gruppe hinzufügen",
  Group_AddError: "Gruppe konnte nicht hinzugefügt werden",
  Group_AddSuccess: "Gruppe wurde erfolgreich hinzugefügt",
  Group_ConfirmDelete: "Willst du die Gruppe wirklich entfernen?",
  Group_DeleteError: "Gruppe konnte nicht entfernt werden",
  Group_EntraIdName: "Entra Id Name",
  Group_EntraIdName_Description: "Wenn du hier eine Entra ID Gruppe (Omada) Gruppe verknüpfst, werden die Mitglieder periodisch importiert. Wenn keine Verknüpfung definiert ist, können die Mitglieder rechts gelöscht und hinzugefügt werden.",
  Group_Id: "Id",
  Group_MemberCount: "# Mitglieder",
  Group_Members: "Mitglieder",
  Group_Name: "Name",
  Group_Search: "Suche Gruppe …",
  Group_SearchStringHint: "Suche nach dem Namen der AD Gruppe.",
  Group_Titles: "AD Gruppen",
  GroupMember_ExistsInGroup: "Existiert in Gruppe",
  Groups: "Gruppen",
  Header_English: "English",
  Header_French: "Français",
  Header_German: "Deutsch",
  Header_Help: "Hilfe",
  Header_Italian: "Italiano",
  Header_Version: "Version",
  Help: "Hilfe",
  HelpMenu_CosProductPage: "COS-Produkt eGPL 2",
  HelpMenu_Manuals: "Anleitungen",
  HelpMenu_Support: "Support",
  HelpMenu_VivaEngage: "Viva Engage Gruppe eGPL 2",
  Helppage: "Hilfeseite",
  Home: "Home",
  Id: "Id",
  ImportedFromPhonebook: "Aus Telefonbuch importierte Felder",
  It: "Italiano",
  KeywordSearch: "Stichwortsuche",
  LastModified: "Zuletzt geändert",
  LastModifiedBy: "Zuletzt geändert von",
  LastSync: "Letzte Synchronisation",
  Loading: "Lade …",
  Logout: "Abmelden",
  Message_Confirm_No: "NEIN",
  Message_Confirm_Question: "Können Sie die Aktion bestätigen?",
  Message_Confirm_Yes: "JA",
  Modified: "Geändert",
  Navigation_Administration: "Administration",
  Navigation_All_Boards: "Alle Gremien",
  Navigation_Completed_Votes: "Erledigte Abstimmungen",
  Navigation_My_Boards: "Meine Gremien",
  Navigation_Open_Votes: "Offene Abstimmungen",
  No: "Nein",
  Ok: "OK",
  OpenLinkNewWindow: "Link öffnen (in neuem Fenster)",
  OriginalPath: "Anfrage Pfad",
  Page_Admin_Title: "Administration",
  Page_Board_Title: "Gremium «{0}»",
  Page_BoardEdit_Title: "Gremium verwalten «{{name}}»",
  Page_Cache_Title: "Cache",
  Page_Claims_Title: "Claims",
  Page_Dashboard_Title: "Dashboard",
  Page_Error_SubTitle: "Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten.",
  Page_Error_Title: "Fehler",
  Page_Group_Title: "Gruppe «{0}»",
  Page_Groups_Title: "Gruppen",
  Page_JobStatus_Title: "Job Status",
  Page_Mails_Title: "Inxmail-Tests",
  Page_Memory_Title: "Speicher",
  Page_Resources_Title: "Übersetzungen",
  Page_Run_Title: "Lauf «{{title}}»",
  Page_Translations_Title: "Übersetzungen",
  Page_User_Title: "User «{0}»",
  Page_UserEdit_Title: "User «{0}» bearbeiten",
  Page_Users_Title: "Users",
  Paging_First: "Erste",
  Paging_Last: "Letzte",
  Paging_Next: "Nächste",
  Paging_Previous: "Vorherige",
  Paging_Stats: "Zeige _START_ bis _END_ von _TOTAL_ Einträgen",
  Paging_StatsFiltered: "(gefiltert von _MAX_ Einträgen)",
  Participant: "Teilnehmende/r",
  Participant_Answered_Stats: "beantwortet {{answered}}/{{totalTopic}}",
  Participant_Answers: "Antworten",
  Participant_Initials: "Initialen",
  Participant_Name: "Name",
  Participant_Role: "Rolle",
  Participant_Status: "Status",
  Participants: "Teilnehmende",
  Permissions: "Berechtigungen",
  Personalisation: "Personalisierung",
  Preview_Report: "Voransicht Protokoll",
  Properties: "Eigenschaften",
  PublishRun_MailSubject: "Email-Betreffzeile",
  PublishRun_MailSubject_Reminder_To_All: "Liebe Teilnehmer*innen es Laufs,<br><br>",
  PublishRun_MailText: "Email-Textinhalt​",
  PublishRun_SendTo: "Empfänger",
  PublishRun_SendType: "Versandart",
  RequestId: "Anfrage ID",
  Reset: "Zurücksetzen",
  RichText_Link_Dialog_Title: "Link bearbeiten",
  RichText_Link_Invalid_URL: "Bitte gib eine gültige URL ein (https://, http://, mailto:)",
  RichText_Link_Remove: "Link entfernen",
  RichText_Link_Text_Label: "Anzeigetext",
  RichText_Link_URL_Label: "Ziel",
  RichText_Paste_Cancel_Tooltip: "Rückgängig machen (Einfügen abbrechen)",
  RichText_Paste_KeepFormatting_Tooltip: "Formatierung beibehalten",
  RichText_Paste_Options_Trigger_Tooltip: "Einfügeoptionen (Strg)",
  RichText_Paste_PlainText_Tooltip: "Nur Text einfügen",
  Richtext_Placeholder: "Text eingeben …",
  RichText_Tooltip_Background: "Hintergrundfrabe",
  RichText_Tooltip_Blockquote: "Als Blockzitat formattieren",
  RichText_Tooltip_Bold: "Fett (Ctrl+B)",
  RichText_Tooltip_Clean: "Formattierung löschen",
  RichText_Tooltip_Color: "Schriftfarbe",
  RichText_Tooltip_Heading: "Überschrift",
  RichText_Tooltip_Indent_Minus1: "Einzug verkleinern (Shift+Tab)",
  RichText_Tooltip_Indent_Plus1: "Einzug vergrössern (Tab)",
  RichText_Tooltip_Italic: "Kursiv (Ctrl+I)",
  RichText_Tooltip_Link: "Einen Link hinzufügen",
  RichText_Tooltip_List_Bullet: "Eine Aufzählung einfügen",
  RichText_Tooltip_List_Ordered: "Eine Nummerierte Liste einfügen",
  RichText_Tooltip_Script_Sub: "Tiefgestellt",
  RichText_Tooltip_Script_Super: "Hochgestellt",
  RichText_Tooltip_Size: "Schriftgrösse",
  RichText_Tooltip_Source: "HTML-Quelltext anzeigen",
  RichText_Tooltip_Strike: "Durchstreichen",
  RichText_Tooltip_Underline: "Unterstreichen (Ctrl+U)",
  Run: "Lauf",
  Run_ArchivedBy: "Archiviert durch",
  Run_ArchiveType: "Archivierungs-Art",
  Run_Boardname: "Gremium",
  Run_ClosedBy: "Geschlossen durch",
  Run_ClosedDate: "Schliesszeit (effektiv)",
  Run_CloseType: "Schliess-Art",
  Run_Comment: "Kommentar",
  Run_Expirydate: "Enddatum",
  Run_Expirytime: "Endzeit",
  Run_Externalid: "Externe Id (SiVe)",
  Run_Key: "Id",
  Run_NotFound: "Kein Lauf vorhanden",
  Run_SiVeTransferResult: "SiVe-Übertragung",
  Run_Status: "Status",
  Run_Title: "Titel",
  RunParticipant: "Lauf-Teilnehmende/r",
  RunParticipant_NotFound: "Benutzer nicht bekannt/vorhanden",
  RunParticipants: "Lauf-Teilnehmende",
  RunParticipants_Add: "Teilnehmende hinzufügen",
  RunParticipants_Invalid: "Falsche Teilnehmende-Liste",
  RunParticipants_SearchMember: "Mitglieder suchen:",
  RunRole_AdditionalParticipant: "zusätzliche Teilnehmende",
  Runs: "Läufe",
  Runs_Empty: "Keine Läufe vorhanden.",
  RunStatus_All: "Alle",
  RunStatus_Archived: "Archiviert",
  RunStatus_ArchivedAndWillBeDeleted: "Archiviert, wird gelöscht am {0}",
  RunStatus_ClosedFromPublished: "Abgeschlossen",
  RunStatus_ClosedFromRepublished: "Abgeschlossen",
  RunStatus_Preparing: "Vorbereitung",
  RunStatus_Published: "Publiziert",
  RunStatus_Republished: "Erneut publiziert",
  RunStatus_Unknown: "Unbekannt",
  RunTopic: "Geschäft",
  RunTopic_Content: "Inhalt",
  RunTopic_Documents: "Dokumente",
  RunTopic_InfoText: "Inhalt (Infotext)",
  RunTopic_Number: "Geschäftsnummer",
  RunTopic_Question: "Inhalt (Question)",
  RunTopic_Result: "Ergebnis",
  RunTopic_Title: "Geschäftstitel",
  RunTopic_TopicKindCode: "Geschäftstyp",
  RunTopics: "Geschäfte",
  RunTopics_Empty: "Keine Geschäfte vorhanden.",
  RunTopicType_Agenda_Content: "Frage zum Agendaeintrag",
  RunTopicType_Decision_Content: "Beschlussvorlage",
  RunTopicType_Info_Content: "Informationsvorlage",
  RunTopicType_Protocol_Content: "Frage zum Protokolleintrag",
  RunTopicVote: "Abstimmungsergebnis",
  RunTopicVotes: "Abstimmungsergebnisse",
  Save: "Speichern",
  Select_Placeholder: "Wählen …",
  SelectAll: "Alle auswählen",
  Send_Mail_Download: "email herunterladen",
  Send_Mail_Publish: "Publizieren",
  Send_Mail_Send: "senden",
  Send_Mail_Send_Reminder_To_All: "Die eDecide-Abstimmungsrunde wurde soeben gestartet. Bitte geben Sie Ihre Stimme bis zum {{expiryDate}} um {{expiryTime}} ab.<br><br>",
  Send_Mail_Text: "Email-Text",
  SendTo_All: "Alle (Teilnehmende und Administrator*innen)",
  SendTo_BoardOwners: "Administrator*innen",
  SendTo_Participants: "Teilnehmende",
  SendTo_ParticipantsWhoNotVoted: "Teilnehmer, die noch nicht abgestimmt haben",
  SendType_DoNotSend: "Keine Email versenden",
  SendType_Download: "Email herunterladen und via Outlook manuell versenden",
  SendType_FromEdecide: "Email aus eDecide direkt versenden",
  Sive_MeetingDoesNotExist: "Der Lauf, dass du schiessen willst, existiert in SiVe nicht mehr!",
  Sive_MeetingMightBeDeleted: "Die Sitzung in SiVe existiert möglicherweise nicht mehr.",
  Sive_Result_IsSentOnClose: "Die Ergebnisse werden nach Abschluss des Laufs an SiVe gesendet.",
  Sive_ResultsWereSent: "Die Ergebnisse wurden bei Abschluss des Laufs an SiVe gesendet.",
  Sive_RunCreatedFromSive: "Dieser Lauf wurde aus einer Sitzung in SiVe erstellt.",
  Statistics: "Statistiken",
  Status_All: "Alle",
  Status_Archived: "Archiviert",
  Status_Button_Archive: "Archivieren",
  Status_Button_Close: "Lauf schliessen",
  Status_Button_Publish: "Publizieren",
  Status_Button_Republish: "Erneut publizieren",
  Status_Button_Revise: "Überarbeiten",
  Status_Closed: "Abgeschlossen",
  Status_Preparing: "Vorbereitung",
  Status_Published: "Publiziert",
  Status_Republished: "Erneut publiziert",
  Status_Revise: "Überarbeitung",
  StatusCode_401_SubTitle: "Du hast keinen Zugriff auf die Ressource.",
  StatusCode_401_Title: "Zugriff verweigert",
  StatusCode_403_SubTitle: "Du hast keine Berechtigungen für den Zugriff auf die Ressource.",
  StatusCode_403_Title: "Verboten",
  StatusCode_404_SubTitle: "Die Ressource wurde nicht gefunden.",
  StatusCode_404_Title: "Nicht gefunden",
  Table_NoRows: "Keine Datensätze gefunden.",
  Tag_Old: "Alt",
  Today: "Heute",
  Topic_Agenda: "Agenda",
  Topic_Decision: "Beschlussvorlage",
  Topic_Info: "Informationsvorlage",
  Topic_Protocol: "Protokolleintrag",
  TopicCode_Agenda_Content: "Agendaeintrag",
  TopicCode_Protocol_Content: "Protokoll",
  Total: "Gesamt",
  User: "User",
  User_AnonymizedDisplayName: "Gelöschter Benutzer",
  User_Boards: "Gremien",
  User_DisplayName: "Name",
  User_Email: "Email",
  User_FirstName: "Vorname",
  User_Initials: "Initialen",
  User_Initials_HelpText: `Wenn du das Feld leer lässt, wird der Standard angewendet.<br/>
Erster Buchstabe des Vornamens, erster Buchstabe des Nachnamens.`,
  User_Initials_Preview: "Vorschau",
  User_Language: "Sprache",
  User_LastName: "Nachname",
  User_LastSync: "Letzte Synchronisation",
  User_OrganisationUnit: "Organisationseinheit",
  User_PersonalSiteUrl: "SharePoint MySite Url (OneDrive)",
  User_PersonnelNumber: "Personal-Nr.",
  User_Phone: "Telefon",
  User_Status: "Status",
  User_Update_Error: "Nutzer*in konnte nicht gespeichert werden: {0}",
  User_Update_Success: "Nutzer*in wurde gespeichert",
  User_Upn: "Prinzipalname",
  User_UserRoles: "Rollen",
  UserMenu_MyDetails: "Mein Profil",
  UserMenu_SignOut: "Abmelden",
  UserPicker: "User nachschlagen",
  UserPicker_NoDataTemplate: "Keine Teilnehmer*innen gefunden",
  UserPicker_Placeholder: "Bezeichner eingeben …",
  UserRole_Administrator: "Administrator",
  UserRole_Application: "Applikation",
  UserRole_Unknown: "Unbekannt",
  UserRole_User: "User",
  Users: "Nutzende",
  UserStatus_Deleted: "Gelöscht",
  UserStatus_Enabled: "Aktiv",
  UserStatus_Unknown: "Unbekannt",
  Validation_At_Least_One_Owner: "Mindestens ein Administrator muss vorhanden sein.",
  Validation_Board_AtLeastOneBoardOwner: "Mindestens ein Administrator muss angegeben werden.",
  Validation_Board_AtLeastOneUser: "Mindestens eine Teilnehmende muss angegeben werden.",
  Validation_Board_DuplicateTopicKindCode: "Es sind doppelte Geschäftstypen vorhanden.",
  Validation_Board_InvalidTopicKindCode: "Es sind ungültige Geschäftstypen vorhanden.",
  Validation_Board_NotUnique: "Das Gremium muss eindeutig sein. Prüfe das Feld 'Nome'.",
  Validation_Board_UniqueKeySizeNot12: "'UniqueKey' muss genau 12 Zeichen lang sein.",
  Validation_Description_NotEmpty: "Beschreibung darf nicht leer sein.",
  Validation_ExpiryDate_Invalid: "Enddatum nicht gültig!",
  Validation_InvalidPosition: "Kann nicht verschieben. Position ungültig.",
  Validation_Name_NotEmpty: "Name darf nicht leer sein.",
  Validation_Required: "'{PropertyName}' ist obligatorisch.",
  Validation_Run_CodesNotUnique: "Die Geschäftsnummern des Laufs müssen eindeutig sein, Duplikate: [{0}].",
  Validation_Run_NotUnique: "Der Lauf muss eindeutig sein im Gremium. Prüfe das Feld 'Titel'.",
  Validation_RunTopic_NotUnique: "Das Geschäft muss eindeutig sein im Lauf. Prüfe das Feld 'Geschäftsnummer'.",
  Validation_TextLongerThanRecommended: "Empfohlen: nicht mehr als {{length}} Zeichen.",
  Validation_Title_NotEmpty: "Titel darf nicht leer sein.",
  ValidationFailures: "Validierungs-Fehler",
  VoteChart_Answered: "Beantwortete Geschäfte",
  VoteChart_NotAnswered: "Nicht beantwortete Geschäfte",
  Votes_NotFound: "Es wurde keine Abstimmungen mit diesen Kriterien gefunden",
  Voting_MyAnswer: "Meine Antwort",
  Voting_MyComment: "Mein Kommentar",
  Voting_RunNotPublished: "Dieser Lauf ist nicht publiziert worden.",
  Yes: "Ja",
};
